import { Title } from 'react-head'
import { Link } from 'react-router'
import styled from 'styled-components'
import { Button } from '@bm-js/atlascloud-ui'
import { ROUTE } from '../cnst/router.cnst'

const StyledEditorMobile = styled.div`
  text-align: center;
`

const EditorMobile = () => {
  return (
    <StyledEditorMobile className='content'>
      <Title>Hemsideredigerare | Atlascloud</Title>
      <p>
        Hemsideredigeraren är för närvarande endast tillgänglig på
        datorversionen av Atlascloud.
      </p>
      <Link to={ROUTE.DASHBOARD}>
        <Button>Tillbaka till start</Button>
      </Link>
    </StyledEditorMobile>
  )
}

export default EditorMobile
